import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBriefcase, FaCar, FaHandshake, FaPlus, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import LogOutModal from "./LogOutModal.jsx";
import { FaComment, FaMagnifyingGlass, FaRightFromBracket } from 'react-icons/fa6';
import ProfileBtn from './ProfileBtn.jsx';
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetDescription } from "./ui/sheet";
import muj_logo from '../muj_logo.png';
import sdc_logo from '../sdc_logo.png';

export const Navbar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const user = localStorage.getItem("user")
  const navigator = useNavigate();
  const [logOutModal, setModal] = useState(false);

  const toggleMenu = () => setMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.querySelector('.sidebar');
      const backdrop = document.querySelector('.backdrop');
      if (sidebar && backdrop && !sidebar.contains(event.target) && backdrop.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    if (isMenuOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  return (
    <>
      {logOutModal ? <LogOutModal setModal={setModal} /> : (
        <nav className="relative sticky top-0 left-0 z-20 w-full bg-white/70 backdrop-blur-xl border-b border-zinc-200">
          <div className="container mx-auto flex items-center justify-between py-3 px-2">
            <Link to={'/'} className="flex justify-center items-center gap-2 text-2xl font-bold ">
              <img src={muj_logo} alt="Travel Buddy Logo" className="h-10 w-10 object-contain" />
              <div className='bg-zinc-600 h-10 w-[2px]' ></div>
              <img src={sdc_logo} alt="SDC Logo" className="h-10 w-14 object-contain" />
              Travel Buddy
            </Link>
            {/* Hamburger for mobile using SheetTrigger */}
            <Sheet open={isMenuOpen} onOpenChange={setMenuOpen}>
              <SheetTrigger asChild>
                <Button id="hamburger-menu" variant="ghost" size="icon" className="lg:hidden" aria-label="Open menu">
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M4 6h16M4 12h16m-7 6h7" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Button>
              </SheetTrigger>
              <SheetContent side="left" className="p-0 w-64">
                <SheetTitle className="sr-only">Navigation Menu</SheetTitle>
                <SheetDescription className="sr-only">Access navigation links and user profile options</SheetDescription>
                <div className="p-4">
                  <div className='mt-4 flex items-center gap-2'>
                    <FaUser className='text-amber-500 p-1 rounded-full bg-white text-4xl' />
                    <div className='flex-1'>
                      <span className='text-amber-500 font-semibold'>Logged In as </span>
                      <p className='text-sm text-zinc-700 truncate'>{user}</p>
                    </div>
                  </div>
                  <hr className='my-4 border-zinc-200' />
                  <Button asChild variant={location.pathname === "/search" || location.pathname === "/" ? "default" : "ghost"} className="w-full mb-2 justify-start" onClick={() => setMenuOpen(false)}>
                    <Link id='search-ride_sm' to="/search" className="gap-1"><FaMagnifyingGlass />Search Rides</Link>
                  </Button>
                  <Button asChild variant={location.pathname === "/create" ? "default" : "ghost"} className="w-full mb-2 justify-start" onClick={() => setMenuOpen(false)}>
                    <Link id='create-ride_sm' to="/create" className="gap-1"><FaPlus />Create Ride</Link>
                  </Button>
                  <Button asChild variant={location.pathname === "/my-rides" ? "default" : "ghost"} className="w-full mb-2 justify-start" onClick={() => setMenuOpen(false)}>
                    <Link id='my-rides_sm' to="/my-rides" className="gap-1"><FaCar />My Rides</Link>
                  </Button>
                  <Button asChild variant={location.pathname === "/my-requests" ? "default" : "ghost"} className="w-full mb-2 justify-start" onClick={() => setMenuOpen(false)}>
                    <Link id='my-requests_sm' to="/my-requests" className="gap-1"><FaHandshake />My Requests</Link>
                  </Button>
                  <Button asChild variant="ghost" className="w-full mb-2 justify-start" onClick={() => setMenuOpen(false)}>
                    <Link id='tnc_sm' to="/terms-and-conditions" className="gap-1"><FaBriefcase />Terms and Conditions</Link>
                  </Button>
                  <Button asChild variant={location.pathname === "/feedback" ? "default" : "ghost"} className="w-full mb-2 justify-start" onClick={() => setMenuOpen(false)}>
                    <Link id='feedback_sm' to="/feedback" className="gap-1"><FaComment />Feedback</Link>
                  </Button>
                  <Button variant="outline" className="w-full flex justify-between items-center text-amber-500 font-semibold mt-2" onClick={() => { setModal(true); setMenuOpen(false); }}>
                    Log Out <FaRightFromBracket className='text-amber-500' />
                  </Button>
                </div>
              </SheetContent>
            </Sheet>
            {/* Desktop nav */}
            <div className="hidden lg:flex items-center gap-2">
              <Button asChild variant={location.pathname === "/search" || location.pathname === "/" ? "default" : "ghost"}>
                <Link id='search-ride_lg' to="/search" className="gap-1"><FaMagnifyingGlass />Search Rides</Link>
              </Button>
              <Button asChild variant={location.pathname === "/create" ? "default" : "ghost"}>
                <Link id='create-ride_lg' to="/create" className="gap-1"><FaPlus />Create Ride</Link>
              </Button>
              <Button asChild variant={location.pathname === "/my-rides" ? "default" : "ghost"}>
                <Link id='my-rides_lg' to="/my-rides" className="gap-1"><FaCar />My Rides</Link>
              </Button>
              <Button asChild variant={location.pathname === "/my-requests" ? "default" : "ghost"}>
                <Link id='my-requests_lg' to="/my-requests" className="gap-1"><FaHandshake />My Requests</Link>
              </Button>
              <ProfileBtn setModal={setModal} />
            </div>
          </div>
        </nav>
      )}
    </>
  );
};